import isEmpty from 'lodash/isEmpty';

export type LabelsFieldOption = {
	id: string | null;
	name: string;
}[];

export const getLabelsFieldValue = (defaultValue: unknown): LabelsFieldOption | null => {
	if (typeof defaultValue === 'string' || typeof defaultValue === 'number') {
		return [{ id: null, name: defaultValue.toString() }];
	}
	const constructedLabels: LabelsFieldOption = [];
	if (Array.isArray(defaultValue)) {
		for (const value of defaultValue) {
			if (typeof value === 'string' || typeof value === 'number')
				constructedLabels.push({ name: value.toString(), id: null });
		}
		return isEmpty(constructedLabels) ? null : constructedLabels;
	}
	return null;
};
